<template>
  <div v-if="modalSettings" class="underlay" @mousedown="underlayClick">
    <customModalDialog :settings="customModalSettings"></customModalDialog>
    <bulkPlacementPopup :settings="bulkPlacementPopupSettings"></bulkPlacementPopup>

    <transition name="slide-fade">
      <div class="sidebar">
        <div class="close" @click="onCancelAction">
          <img alt="Close" src="@/assets/icons/ic_close_white.svg">
        </div>
        <h2 class="sidebar_title">{{ settings.title }}</h2>
        <h3 v-if="settings.description" class="sidebar_description">{{ settings.description }}</h3>
        <div class="moreOptionSidebar__wrapper" @click="createQuestion">
          <div class="moreOptionSidebar__icon">
            <img src="@/assets/icons/ic_add.svg">
          </div>
          <div class="moreOptionSidebar__text">
            <span class="createQuestion__text">{{translate('own_createQuestion')}}</span>
          </div>
        </div>
        <router-link class="moreOptionSidebar__wrapper" :to="{name: 'orderPage'}">
          <div class="moreOptionSidebar__icon">
            <img src="@/assets/icons/ic_order.svg">
          </div>
          <div  class="moreOptionSidebar__text">
            <span class="createQuestion__text">{{translate('orderStickersBtn')}}</span>
          </div>
        </router-link>
        <button  @click="ReportPopupMobile" class="exportWrapper">
          <a class="exportLink">
            <div class="exportText">
              {{translate('exportRawData')}}
            </div>
            <div class="exportIcon">
              <img src="@/assets/icons/ic_export_row.svg">
            </div>
          </a>
        </button>
        <div class="bulk-placement">
          <div class="bulk-placement__wrapper" @click="bulkPlacementPopupClick">
            <div class="bulk-placement__icon">
              <img src="@/assets/icons/ic_house.svg">
            </div>
            <div class="bulk-placement__text">
              {{translate('bulkPlacement')}}
            </div>
          </div>
        </div>
        <div class="all-votes">
          <div class="all-votes__wrapper" @click="showAllvotesBtnClick">
            <div class="all-votes__icon">
              <img src="@/assets/icons/ic_data_index.svg">
            </div>
            <div>
              <div class="moreOptionSidebar__text">
                <span class="createQuestion__text">{{translate('showAllVotes')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from "lodash";
import $ from 'jquery'
import logAnalyticsEvent, {logError} from '@/helpers/analytics'
import {mapActions, mapMutations} from 'vuex';
import moment from "moment";
import customModalDialog from '@/components/widgets/customModalDialog';
import bulkPlacementPopup from "@/components/widgets/bulkPlacementPopup";

export default {
  name: "moreOptionsSidebar",

  data() {
    return {
      modalSettings: !_.isEmpty(this.settings),
      customModalSettings: {},
      bulkPlacementPopupSettings: {},
    }
  },
  watch: {
    settings(newValue) {
      this.modalSettings = !_.isEmpty(newValue)
    },
  },
  components: {
    customModalDialog,
    bulkPlacementPopup,
  },
  props: {
    settings: {
      type: [Object, null],
      default: () => {
        return {
          validate: true
        }
      }
    },
  },

  methods: {
    ...mapActions({
      openFileReport: 'organization/openFileReport',
      checkReport: 'organization/checkReport',
      getReportOnMobile: 'organization/getReportOnMobile'
    }),
    ...mapMutations({
      setSideBarToggle: 'owner/setSideBarToggle',
    }),
    async onCancelAction() {
      this.modalSettings = false
      this.dropdownChoose = null
      this.setSideBarToggle(false)
      if (this.settings.onCancelAction) {
        try {
          await this.settings.onCancelAction(this.settings)
        } catch (error) {
          this.showErrorModal(error.message)
        }
      }
    },
    async fetchReport(type, dataType = 'full') {
      switch (type) {
        case 'xlsx':
          logAnalyticsEvent(`analytics_generate_xlsx_report_click`)
          break
      }
      let dateFromLocal = this.settings.dateFrom ? moment(new Date(this.settings.dateFrom)).format("YYYY-MM-DD HH:mm:ss") : null
      let dateToLocal = this.settings.dateTo ? moment(new Date(this.settings.dateTo)).format("YYYY-MM-DD HH:mm:ss") : null
      let placeUids = this.settings.placeUids
      let data = {
        date_from_local: dateFromLocal,
        date_to_local: dateToLocal,
        place_uids: placeUids,
        type: type
      }
      try {
        const response = await this.checkReport(data)
        if (response.success) {
          this.openFileReport({dateFromLocal, dateToLocal, placeUids, type, dataType})
            this.onCancelAction()
        }
      } catch (e) {
        logError('check_report', e.data.error.message || '')
        this.customModalSettings = {
          sectionClass: 'full-width--btn large',
          icon: 'ic_allow.svg',
          message: this.translate('dataReportPopup'),
          okButtonText: this.translate('Close'),
          onOkHandler: () => {
            this.customModalSettings = null
          },
            onCancelHandler: () => {
            this.customModalSettings = null
          }
        }
      }

    },
    underlayClick(e) {
      if (($(".underlay").has(e.target).length === 0)) {
        this.onCancelAction()
      }
    },
    bulkPlacementPopupClick() {
      this.bulkPlacementPopupSettings = {
        show: true,
          successHandler: this.settings.bulkPlacementEditSuccess,
      }
    },
      async ReportPopupMobile() {
          if (window.matchMedia("(max-width: 557px)").matches) {
              try {
                  let dateFromLocal = this.settings.dateFrom ? moment(new Date(this.settings.dateFrom)).format("YYYY-MM-DD HH:mm:ss") : null
                  let dateToLocal = this.settings.dateTo ? moment(new Date(this.settings.dateTo)).format("YYYY-MM-DD HH:mm:ss") : null
                  let placeUids = this.settings.placeUids
                  let type = 'xlsx'
                  let dataType = 'mobile'
                  let data = {
                      date_from_local: dateFromLocal,
                      date_to_local: dateToLocal,
                      place_uids: placeUids,
                      type: type,
                  }
                  const response = await this.checkReport(data)
                  if (response.success) {
                      this.customModalSettings = {
                          icon: 'ic_allow.svg',
                          message: this.translate('dataReportPopupMobileXLSX'),
                          onOkHandler: this.fetchXLSReportOnMobile.bind(null),
                          onCancelHandler: () => {
                              this.customModalSettings = null
                          }
                      }
                  }
              } catch (e) {
                  logError('check_report', e.data.error.message || '')
                  this.customModalSettings = {
                      sectionClass: 'full-width--btn large',
                      icon: 'ic_allow.svg',
                      message: this.translate('dataReportPopup'),
                      okButtonText: this.translate('Close'),
                      onOkHandler: () => {
                          this.customModalSettings = null
                      },
                      onCancelHandler: () => {
                          this.customModalSettings = null
                      }
                  }
              }
          } else {
              console.log('bag')
              this.fetchReport('xlsx')
          }
      },
    async fetchXLSReportOnMobile() {
      let dateFromLocal = this.settings.dateFrom ? moment(new Date(this.settings.dateFrom)).format("YYYY-MM-DD HH:mm:ss") : null
      let dateToLocal = this.settings.dateTo ? moment(new Date(this.settings.dateTo)).format("YYYY-MM-DD HH:mm:ss") : null
        let placeUids = this.settings.placeUids
        let type = 'xlsx'
        let dataType = 'mobile'
      try {
          this.openFileReport({dateFromLocal, dateToLocal, placeUids, type, dataType})
          this.onCancelAction()
      } catch (e) {
        logError('check_report', e.data.error.message || '')
        this.customModalSettings = {
          sectionClass: 'full-width--btn large',
          icon: 'ic_allow.svg',
          message: this.translate('dataReportPopup'),
          okButtonText: this.translate('Close'),
            onOkHandler: () => {
                this.customModalSettings = null
            },
            onCancelHandler: () => {
                this.customModalSettings = null
            }
        }
      }

    },
    async createQuestion () {
      this.modalSettings = false
      if (this.settings.createQuestionHandler) {
        try {
          await this.settings.createQuestionHandler(this.settings)
        } catch (error) {
          this.showErrorModal(error.message)
        }
      }
    },
    showAllvotesBtnClick() {
      this.modalSettings = false
      this.settings.showAllVotesHandler()
    },

  }
}
</script>


<style scoped>
.btn-secondary {
  background-color: #F3F3F3 !important;
  color: black !important;
}
.sidebar {
  height: 100vh;
  overflow-x: hidden;
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 400px;
  /*min-width: 350px;*/
  padding: 25px;
  z-index: 9999;
  box-shadow: -.5vw 0 .5vw 0 rgba(0, 0, 0, 0.25);
}
.sidebar .close {
  position: unset;
  top: 0;
  right: 0;
}

.sidebar .close img {
  width: 17px;
  height: 17px;
  cursor: pointer;
}

.sidebar_top {
  position: relative;
  padding-top: 2vw;
}

.sidebar_title {
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 1vw;
}

.sidebar_description {
  font-size: 14px;
  line-height: 22px;
  margin-top: 1vw;
  margin-bottom: 1vw;
  font-weight: 700;
}

.sidebar_content li {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  margin-bottom: 15px;
}

.sidebar_content .icon-wrap {
  min-width: 34px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar_content .icon-wrap-right {
  color: #2F2F2F;
  min-width: 28px;
  margin-left: 8px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 2px solid #2F2F2F;
  border-radius: 4px;
}

.sidebar_content li img {
  margin-right: 8px;
  max-width: 24px;
  max-height: 24px;
  opacity: .5;
}

.sidebar_content .icon-wrap-right img {
  margin-right: 0px;
  max-width: 20px;
  max-height: 20px;
  opacity: 1;
}
.createQuestion__text {
  color: black !important;
  font-family: 'Nunito';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  margin-left: 15px;
}
.moreOptionSidebar__wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  cursor: pointer;
  outline: none;
  text-decoration: none;
}
.moreOptionSidebar__wrapper:hover {
  text-decoration: none;
  outline: none;
}
.owner-filter__bottom .range .dropdown-range {
  padding: 5px 0px 15px;
  background-color: #FFFFFF;
}
.dropdown-toggle::after {
  display: none !important;
}
.exportWrapper {
  display: flex;
  align-items: center;
  position: relative;
  border: none;
  box-sizing: border-box;
  border-radius: 6px;
  margin-right: 8px;
  background-color: white;
  padding: 0;
}
.exportLink {
  display: flex;
  flex-direction: row-reverse;
  text-decoration: none !important;
  outline: none;
}
.exportLink:hover {
  text-decoration: none !important;
  outline: none;
  cursor: pointer;
}
.exportIcon {
  margin-right: 15px;
  color: black;
}
.exportText {
  color: black;
  font-family: 'Nunito';
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
}
.exportDropdawn {
  position: absolute;
  z-index: 9999;
  border-radius: 4px;
  background-color: #FFFFFF;
  box-shadow: 0 10px 11px 0 rgba(0,0,0,0.11);
  height: 48px;
  width: 220px;
  top: 35px;
  left: 0;
  display: flex;
  align-items: center;
  display: none;
}
.exportDropdawn.active {
  display: block;
}
.dropdawnLink {
  height: 48px;
  text-align: center;
}
.dropdawnLink:hover {
  background-color: rgba(109, 109, 109, 0.1);
  color: black;
}
.button-group__wrapper {
  display: flex;
}
.dropdawnXLSX {
  color: #2F2F2F;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
  padding-top: 13px   ;
}
.dropdawnXLSX:hover {
  cursor: pointer;
}
.bulk-placement__wrapper {
  display: flex;
  align-items: center;
  margin-top: 32px;
  cursor: pointer;
}
.bulk-placement__text {
  margin-left: 15px;
}
.all-votes {
  margin-top: 32px;
  cursor: pointer;
}
.all-votes__wrapper {
  display: flex;
}

@media screen and (max-width: 1000px) {
  .sidebar {
    width: 97vw;
    padding: 25px 15px 10px;
    box-shadow: -10px 0 14px 0 rgba(0, 0, 0, 0.25);
  }

  .sidebar .close img {
    width: 24px;
  }

  .sidebar_top {
    padding-top: 30px;
  }

  .sidebar_title {
    font-size: 18px;
    margin-bottom: 30px;
  }

  .sidebar_content li {
    margin-top: 20px;
  }

  .sidebar_content .md-field .md-input {
    font-size: 16px;
    padding: 6px;
    height: auto;
  }

  .sidebar_content .md-field label {
    bottom: 0 !important;
    top: unset !important;
  }

  .sidebar_content .md-field.md-focused label,
  .sidebar_content .md-field.md-has-value label {
    font-size: 14px;
    top: unset !important;
    bottom: 23px !important;
  }

  /*.sidebar_content .md-field .md-count {*/
  /*  font-size: 2.65vw;*/
  /*  height: 2.05vw;*/
  /*  bottom: -2.1vw;*/
  /*}*/
  /*.md-field.md-invalid .md-error {*/
  /*  font-size: 2.7vw;*/
  /*  line-height: 2.25vw;*/
  /*  height: 2vw;*/
  /*  bottom: -3vw;*/
  /*}*/
  .sidebar_content li img {
    margin-right: 7px;
    width: 22px
  }

}

@media screen and (max-width: 516px) {
  .sidebar_content li {
    margin-bottom: -20px;
  }

  .sidebar_title {
    margin-bottom: 10px;
  }
}
</style>
